let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6zoIr")).then(() => parcelRequire('1xyxZ'));